import { Component, Input } from '@angular/core';
import { UI_APPLIST_TYPE } from 'src/app/core/enums/ui.enum';
import { ApplicationWizard } from 'src/app/core/models/application-wizard.model';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-application-list',
  templateUrl: './application-list.component.html',
  styleUrls: ['./application-list.component.scss']
})
export class ApplicationListComponent {

  @Input() appList: ApplicationWizard[] = [];
  @Input() applistType: UI_APPLIST_TYPE = UI_APPLIST_TYPE.agactive;
  constructor(
    private userService: UserService
  ){

  }

  getAppList(){
    return this.appList;
  }
}
